module.exports = __webpack_public_path__ + "img/Connections.f5ebf171.svg";